<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable max-len -->
<template lang="pug">
#modal-version.modal.modal-lg.fade(tabindex='-1')
  .modal-dialog
    .modal-content
      .modal-body
        .modal-version-body
          .modal-version-fields
            h2 Versão
            h4.mt-4 FRONTEND
            p #[strong tag]: "{{ model.front.tag }}",
            p #[strong buildDate]: "{{ model.front.buildDate }}"
            p #[strong branch]: "{{ model.front.branch }}"
            p #[strong commit]: "{{ model.front.commit }}"
            p #[strong buildNumber]: "{{ model.front.buildNumber }}"
            p #[strong repo]: "{{ model.front.repo }}"

            h4 BACKEND:
            p #[strong tag]: "{{ model.back.tag }}",
            p #[strong buildDate]: "{{ model.back.buildDate }}"
            p #[strong branch]: "{{ model.back.branch }}"
            p #[strong commit]: "{{ model.back.commit }}"
            p #[strong buildNumber]: "{{ model.back.buildNumber }}"
            p #[strong repo]: "{{ model.back.repo }}"
          .modal-version-image
            img(
              src='@/assets/images/cafe.svg',
              alt='Imagem ilustrativa de uma mão segunrando café'
            )
      .modal-footer
        button.btn.btn-primary(
          type='button',
          data-bs-dismiss='modal',
          aria-label='Close'
        ) Fechar

button.btn.btn-tag.btn-sm.btn-grayscale-dark.btn-version(
  type='button',
  data-bs-target='#modal-version',
  data-bs-toggle='modal'
) {{ `V.${model.front.tag}` }}
</template>

<script lang="ts">
  import systemController from '@/infra/base/system.controller'
  import { defineComponent } from 'vue'
  import config from '../../../config'

  type VersionObjectType = {
    tag: string | null
    buildDate: string | null
    branch: string | null
    commit: string | null
    buildNumber: string | null
    repo: string | null
  }

  interface IModelVersion {
    front: VersionObjectType
    back: VersionObjectType
  }

  export default defineComponent({
    name: 'VersionButtonComponent',
    data: () => ({
      model: {
        front: {
          tag: null,
          buildDate: null,
          branch: null,
          commit: null,
          buildNumber: null,
          repo: null,
        },
        back: {
          tag: null,
          buildDate: null,
          branch: null,
          commit: null,
          buildNumber: null,
          repo: null,
        },
      } as IModelVersion,
    }),
    mounted() {
      this.getDataVersion()
    },
    methods: {
      async getDataVersion() {
        const response: VersionObjectType = await systemController.getVersion()
        const frontObj = {
          ...config.version,
          buildDate: config.version.date,
          buildNumber: config.version.build,
        }
        const model = { front: { ...frontObj }, back: { ...response } }
        this.model = model
      },
    },
  })
</script>

<style lang="stylus" scoped>

  @media screen and (max-width: 990px)
    .modal-version-image
      img
        display: none

    .modal-version-fields
      font-size: 1rem
      text-align: center
      p
        line-height: normal !important
  .modal-header
    display: none
  .modal-version-body
    display: flex;
    flex-column: row
  .modal-version-fields
    text-align: left
    flex-grow: 1

    p
      line-height: 0.8rem
  .modal-version-image
    img
      width: 20.5rem

  .btn-version
    padding: 0.24rem 0.54rem;
    font-size: 0.875rem;
    justify-content: center;
    align-items: center;
    background-color: var(--color-grayscale-default-600);
    border-color: var(--color-grayscale-default-600);
    color: #FFFFFF;
</style>
